'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["diff", "config"];
import { IFRAME_STATE_SYNCED } from './ActionTypes';
export const syncIframeState = payload => {
  const {
      diff,
      config
    } = payload,
    rest = _objectWithoutPropertiesLoose(payload, _excluded);
  return {
    type: IFRAME_STATE_SYNCED,
    payload: Object.assign({}, rest, {
      diff,
      config
    })
  };
};